export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-6f-e16f15702656730e4bcb7ab385a0d63f.webp";